import React from "react";
import { usefulllinks } from "./footerData";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { handleTopScroll } from "../../../common/function/ScroolTop";

const UseFullLinks = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    handleTopScroll();
    navigate(path);
  };
  return (
    <div>
      <h2 className="footer-heding">Usefull links</h2>
      {usefulllinks?.map((v, i) => {
        return (
          <p className={`my-2.5 font-medium flex items-center cursor-pointer hover:text-white `} key={i}>
            <span>
              <MdKeyboardDoubleArrowRight className="mr-0.5 w-5 h-5" />
            </span>
            <p onClick={() => handleNavigate(v.path)}>{v?.title}</p>
          </p>
        );
      })}
    </div>
  );
};

export default UseFullLinks;
